export default __webpack_public_path__ + "static/media/dx071101.d2e69faa.jpg";